/**
 * Notice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The FormativeAction model module.
 * @module model/FormativeAction
 * @version 1.0
 */
class FormativeAction {
    /**
     * Constructs a new <code>FormativeAction</code>.
     * @alias module:model/FormativeAction
     */
    constructor() { 
        
        FormativeAction.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>FormativeAction</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FormativeAction} obj Optional instance to populate.
     * @return {module:model/FormativeAction} The populated <code>FormativeAction</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FormativeAction();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('academic_program')) {
                obj['academic_program'] = ApiClient.convertToType(data['academic_program'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }


}

/**
 * Class FormativeAction
 * @member {Number} id
 */
FormativeAction.prototype['id'] = undefined;

/**
 * Class FormativeAction
 * @member {Number} academic_program
 */
FormativeAction.prototype['academic_program'] = undefined;

/**
 * Class FormativeAction
 * @member {String} name
 */
FormativeAction.prototype['name'] = undefined;






export default FormativeAction;

